// @greenlight-spec: 16-api-conventions.md
// @greenlight-spec: 11-observability.md#app-usage-collection
import { initContract } from '@ts-rest/core';
import { AppUsageSchema, AppUsageSummaryResultSchema, AppUsageWindowQuerySchema, } from '@greenlight/shared';
import { AppIdParamsSchema, errorResponses } from './common.js';
const c = initContract();
export const usageContract = c.router({
    getAppUsage: {
        method: 'GET',
        path: '/api/apps/:id/usage',
        pathParams: AppIdParamsSchema,
        query: AppUsageWindowQuerySchema,
        responses: {
            200: AppUsageSchema,
            ...errorResponses,
        },
        summary: 'Per-app usage analytics over a trailing window (default 30 days, max 60): sparse per-day request/active-user series, exact distinct users over the window, and last authenticated access. Aggregates metered at /auth/check; IT-only.',
    },
    getSummary: {
        method: 'GET',
        path: '/api/apps/usage-summary',
        query: AppUsageWindowQuerySchema,
        responses: {
            200: AppUsageSummaryResultSchema,
            ...errorResponses,
        },
        summary: 'Fleet-level per-app usage aggregate over one shared window (traffic weighting for the master system map): request volume, distinct active users, and last-active per live app. IT-only.',
    },
});
//# sourceMappingURL=usage.js.map